"use client";

import { motion } from "framer-motion";
import Image from "next/image";

export default function Hero() {
  return (
    <section className="min-h-[94vh] relative text-center flex flex-col gap-5 justify-center overflow-hidden">
      {/* Hero Background Image - Optimized for LCP */}
      <Image
        src="/house.webp"
        alt="Davis Construction - Professional construction services in Broward County"
        fill
        priority
        fetchPriority="high"
        quality={90}
        sizes="100vw"
        className="object-cover"
      />
      
      <div className="mx-10 z-10 space-y-5">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="font-bold text-4xl md:text-6xl"
        >
          Building{" "}
          <span className="bg-gradient-to-r from-white to-amber-500 bg-clip-text text-transparent">
            Excellence
          </span>{" "}
          <br />
          Since 1974
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15 }}
          className="max-w-lg text-white text-sm md:text-lg mx-auto font-light"
        >
          Davis Construction Group: A family-owned business delivering top-tier
          construction services to Davie, Southwest Ranches, Cooper City, and
          surrounding areas for over 50 years.
        </motion.p>
      </div>
      <div className="absolute inset-0 backdrop-blur-sm z-[1]" />
      <div className="absolute w-full h-16 bottom-0 bg-gradient-to-t from-background to-yellow-500 z-[1]" />
    </section>
  );
}
